module.exports = __webpack_public_path__ + "static/media/location.4624a96d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/location.svg
// module id = 2836
// module chunks = 0